<template>
  <Modal ref="smallModal" title="Informações" class="modal-container">
    <div class="loading" v-if="loaded">
      <LoadingSpinner />
    </div>

    <Tabs
      v-else
      :options="[
        'Dados básicos',
        'Alunos regulares',
        'Alunos reposição',
        'Aulas',
        'Presenças',
        'Feedback',
      ]"
    >
      <div slot="Dados básicos" class="dados-container">
        <div class="dados-row">
          <div class="dados-item">
            <strong>Agrupamento:</strong>
            <span>{{ turma.id_agrupamento }}</span>
          </div>

          <div class="dados-item">
            <strong>Data de inicio:</strong>
            <span>{{ utils.formatDate(turma.data_inicio) }}</span>
          </div>

          <div class="dados-item">
            <strong>Data de finalização:</strong>
            <span>{{ utils.formatDate(turma.data_fim) }}</span>
          </div>
        </div>

        <div class="dados-row" v-if="user == 'admin' && id_role == 1">
          <Button
            @handle:click="getStatus(turma)"
            text="Atualizar status"
            color="primary"
            v-if="turma.coleta_informada"
            :disabled="btnGetStatus"
          />
          <Button
            @handle:click="cancelarTurma(turma.id_turma_teorica)"
            text="Cancelar turma"
            color="danger"
            v-if="turma.coleta_informada && turma.virtual"
            :disabled="loading"
          />
        </div>
      </div>
      <div slot="Alunos regulares" class="dados-container">
        <alunos-regulares :idTurma="turma.id_turma_teorica" :virtual="turma.virtual" />
      </div>
      <div slot="Alunos reposição" class="dados-container">
        <alunos-reposicao :idTurma="turma.id_turma_teorica" />
      </div>
      <div slot="Aulas" class="dados-container">
        <aulas :idTurma="turma.id_turma_teorica" />
      </div>
      <div slot="Presenças" class="dados-container">
        <alunos
          :idTurma="turma.id_turma_teorica"
          :virtual="turma.virtual"
          :idRole="id_role" />
      </div>
      <div slot="Feedback" class="dados-container">
        <feedback :idTurma="turma.id_turma_teorica" />
      </div>
    </Tabs>
  </Modal>
</template>

<script>
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Modal from 'core/Modal'
import Tabs from 'core/Tabs'

import utils from '../../services/utils'

import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import TableAlunosReposicao from './TableAlunosReposicao'
import TableAlunosTurma from './TableAlunosTurma'
import TableAulasTurma from './TableAulasTurma'
import TableFeedbacks from './TableFeedbacks'
import TablePresencas from './TablePresencas'
import TurmasController from './TurmasController'

import AlunosRegulares from './src/TableAlunosRegulares.vue'
import AlunosReposicao from './src/TableAlunosReposicao.vue'
import Aulas from './src/TableAulas.vue'
import Alunos from './src/TableAlunos.vue'
import Feedback from './src/TableFeedBack.vue'

export default {
  name: 'InfoModal',
  components: {
    Modal,
    Tabs,
    LoadingSpinner,
    Button,

    ...spinners,
    TableAlunosTurma,
    TableAlunosReposicao,
    TableAulasTurma,
    TablePresencas,
    TableFeedbacks,

    AlunosRegulares,
    AlunosReposicao,
    Aulas,
    Alunos,
    Feedback
  },
  data() {
    return {
      utils: utils,
      id_role: localStorage.id_role,
      user: '',
      turma: null,
      loading: false,
      loaded: true,

      modal: {
        show: false,
        load: false,
        conteudo: {},
      },
      historico: false,
      regular: false,
      reposicao: false,
      aula: false,
      feedback: false,
      btnGetStatus: false,
    }
  },
  created() {
    const email = localStorage.email.split('@')
    this.user = email[0]
  },
  methods: {
    async open(id) {
      this.regular = false
      this.reposicao = false
      this.aula = false
      this.historico = false
      this.feedback = false

      this.$refs.smallModal.open()

      await this.detalhes(id)
    },
    async detalhes(id) {
      this.loaded = true
      await this.$http
        .get(`${process.env.VUE_APP_URL_API}/turmas/${id}`)
        .then(({ body }) => {
          this.turma = body.dados
        })
        .catch(({ body }) => {
          this.$refs.smallModal.close()

          this.$toasted.show(body.dados, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loaded = false
        })
    },
    ativar(opcao) {
      if (opcao == 'Alunos Regulares') {
        this.reposicao = false
        this.aula = false
        this.historico = false
        this.feedback = false
        this.regular = true
      } else if (opcao == 'Alunos Reposição') {
        this.aula = false
        this.historico = false
        this.feedback = false
        this.regular = false
        this.reposicao = true
      } else if (opcao == 'Aulas') {
        this.historico = false
        this.feedback = false
        this.regular = false
        this.reposicao = false
        this.aula = true
      } else if ('Presenças') {
        this.feedback = false
        this.regular = false
        this.reposicao = false
        this.aula = false
        this.historico = true
      }

      if (opcao == 'Feedback') {
        this.regular = false
        this.reposicao = false
        this.aula = false
        this.historico = false
        this.feedback = true
      }
    },
    async getStatus(turma) {
      this.btnGetStatus = true

      await this.$http
        .post(urlApi + '/turmas/get/status', turma)
        .then(response => {
          this.toast(
            response.body.mensagem + ', Consulte a turma novamente para atualizar os status.'
          )
        })
        .catch(err => {
          this.toast(err.body.mensagem)
        })
        .finally(() => {
          this.btnGetStatus = false

          this.$refs.smallModal.close()

          this.$emit('reload')
        })
    },
    paginaEdicao(idTurma) {
      TurmasController.paginaEdicao(idTurma)
    },
    cancelarTurma(idTurma) {
      this.$http
        .get(urlApi + `/turmas/cancelar/${idTurma}`)
        .then(response => {
          TurmasController.launchToast('fa-check', 'Sucesso', 'top-center')
        })
        .catch(error => {
          TurmasController.launchToast('fa-times', error.data.dados, 'top-center')
        })
        .finally(() => {
          this.$refs.smallModal.close()

          this.$emit('reload')
        })
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dados-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .dados-row {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 1rem;

      .dados-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;

        strong {
          font-weight: 600;
          color: #1c2d5a;
        }

        span {
          font-weight: 400;
          font-size: 0.875rem;
        }
      }

      > button {
        flex: 1;
        justify-content: center;
      }
    }
  }
}
</style>
